// Angular Imports
import {Pipe, PipeTransform} from '@angular/core'

@Pipe({
	name: 'lowerCaseNumber',
	standalone: true,
})
export class LowerCaseNumberPipe implements PipeTransform {
	transform(value: any, ...args: Array<unknown>): string {
		if (typeof value === 'string') {
			return this._lowercase(value)
		} else if (typeof value === 'number') {
			return value.toString() // We only return the number as a string
		} else {
			return '' // Handle other data types as desired
		}
	}

	private _lowercase(string: string): string {
		return string.toLowerCase()
	}
}
